import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Table from '../../components/table/table.jsx';
import { PopupService } from '../../services/popup_service.jsx';
import NotificationPopup from '../../components/popups/notification_popup.jsx';
import { NotificationButtons } from "../../components/popups/popup_constants.js";
import { useHistory } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization.js';
import { hasModuleAccess } from '../../services/accessService.js';
import { AccessLevel, AppModules } from '../../constants/appAccess.js';
import roleManagementService from '../../services/roleManagementService.js';
import EditButton from '../../components/table/components/buttons/edit_button.js';
import DeleteButton from '../../components/table/components/buttons/delete_button.js';



const RolesList = (props) => {
    const roles = useSelector((state) => state.roles.roles);
    const filter = useSelector((state) => state.roles.filter);
    //const [modelFilter, setModelFilter] = useState({});
    const history = useHistory();
    const { t } = useLocalization();

    useEffect(() => {
        getData();
    }, []);

    const getData = (applyFilter) => {
        applyFilter = applyFilter ? applyFilter : filter;
        roleManagementService.getRolesAsync(applyFilter);
    }

    const addRole = () => {
        history.push('/roles/addRole');
    }

    const editRole = (role) => {
        history.push('/roles/editRole/' + role.roleName);
    }

    const removeRoleAction = (role) => {
        const header = t('RoleManagement.removeRolePopupHeader');
        const message = t('RoleManagement.removeRolePopupMessage')
            .replace("{role name}", role.roleName);
        const element = React.createElement(NotificationPopup,
            {
                header: header,
                message: message,
                buttons: [NotificationButtons.OK, NotificationButtons.CANCEL],
                submitAction: () => {
                    roleManagementService.deleteRoleAsync(role.roleName)
                    //cardService.removeCardAsync(card);
                }
            });
        PopupService.showPopup(element);
    }

    const Columns = [
        {
            header: "RoleManagement.roleName",
            name: "roleName"
        },
        {
            header: "RoleManagement.roleDescription",
            name: "description"
        },
        {
            dataType: "custom",
            render: (item) => (<>
                {
                    hasModuleAccess(AppModules.RoleManagement, AccessLevel.Write) && item.roleName.toLowerCase() != 'admin' &&
                    <EditButton onClick={() => editRole(item)}></EditButton>
                }
            </>)
        },
        {
            dataType: "custom",
            render: (item) => (<>
                {
                    hasModuleAccess(AppModules.RoleManagement, AccessLevel.Write) && item.roleName.toLowerCase() != 'admin' &&
                    <DeleteButton onClick={() => removeRoleAction(item)}></DeleteButton>
                }
            </>)
        }
    ];

    return (
        <div>
            <Table settings={{
                columns: Columns,
                items: roles,
                itemsFilter: Object.assign({}, filter),
                getItemsFunction: getData,
                addItemFunction: hasModuleAccess(AppModules.RoleManagement, AccessLevel.Write) ? addRole : undefined,
                keyField: "roleName"
            }} />
        </div>
    );
}


export default RolesList;